export function humanReadableSize(size: number) {
  const units = ["B", "KB", "MB", "GB", "TB"];
  let i = 0;
  while (size >= 1024) {
    size /= 1024;
    i++;
  }
  return `${size.toFixed(1)} ${units[i]}`;
}

export function encodeKey(key: string) {
  return key.split("/").map(encodeURIComponent).join("/");
}

export function validName(name: string) {
  const trimmed = name.trim();
  return (
    Boolean(trimmed) &&
    !/[\\/]/.test(trimmed) &&
    trimmed !== "." &&
    trimmed !== ".."
  );
}

export function joinKey(base: string, name: string) {
  return `${base.replace(/\/?$/, "/")}${name}`.replace(/^\/+/, "");
}
